module.exports = __webpack_public_path__ + "img/img3.77cf5b03.png";